import React, { useState, useCallback } from "react";
import { SettingToggle, Banner, Card } from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { actFetchDataSettings } from "../../actions/index";
const Checkify = () => {
  const dispatch = useDispatch();
  const dataSettings = useSelector((state) => state.dataSettings);

  return (
    <div style={{ marginTop: "20px" }} className="notify buyer-page">
      <Card sectioned title="ClichFunnels & Checkify Setup">
        When you use Clickfunnels, we need your client ID and secret to connect
        with Clickfunnels and sync the tracking information.
        <br /> Please follow these steps below and update me required info:
        <br />
        <div className="ml-3 mt-2" style={{ lineHeight: "24px" }}>
          1. Login to{" "}
          <a
            href="https://developer.paypal.com/developer/applications/"
            target="_blank"
          >
            Paypal Developer Dashboard.
          </a>{" "}
          <br />
          2. On <b>My Apps & Credentials</b> menu, Click <b>Live</b> box. <br />
          3. Click <b>Create App</b>. <br />
          4. Type <b>App Name</b> and click <b>Create App</b>. <br />
          5. In the <b>APP SETTINGS</b> box, in the App feature options section.
          You have selected <b>Disputes and Transaction Search</b> to authorize
          us to send Tracking code
          <br />
          6. Copy Client ID & Secret and send me
        </div>
      </Card>
    </div>
  );
};

export default Checkify;
